// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8a40a1ed","732":"262fab28","977":"6cda28ba"}[chunkId] + ".chunk.js";
};